import React, { useEffect, useRef, useState } from "react";
import { motion } from "motion/react";
import { Helmet } from "react-helmet";
import { Col, Container, Row } from "react-bootstrap";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import SectionHeader from "../components/sectionHeader";
import Masonry, {ResponsiveMasonry} from "react-responsive-masonry"
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
const GalleryPage = () => {
    const galleryRef = useRef(null);
      const [hasLoaded, setHasLoaded] = useState(false);
    
      useEffect(() => {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
        const timer = setTimeout(() => setHasLoaded(true), 100);
        return () => clearTimeout(timer);
      }, []);

      useEffect(() => {
        // Ensure Fancybox is bound correctly
        NativeFancybox.bind("[data-fancybox='gallery']", {});
        return () => {
          NativeFancybox.destroy();
        };
      }, []);

      const galleryItems = [
        {
            path: "/images/gallery/gallery-1.webp"
        },
        {
            path: "/images/gallery/gallery-2.webp"
        },
        {
            path: "/images/gallery/gallery-3.webp"
        },
        {
            path: "/images/gallery/gallery-4.webp"
        },
        {
            path: "/images/gallery/gallery-5.webp"
        },
        {
            path: "/images/gallery/gallery-6.webp"
        },
        {
            path: "/images/gallery/gallery-7.webp"
        },
        {
            path: "/images/gallery/gallery-8.webp"
        },
        {
            path: "/images/gallery/gallery-9.webp"
        },
        {
            path: "/images/gallery/gallery-10.webp"
        },
        {
            path: "/images/gallery/gallery-11.webp"
        },
        {
            path: "/images/gallery/gallery-12.webp"
        },
        {
            path: "/images/gallery/gallery-13.webp"
        },

        {
            path: "/images/gallery/gallery-14.webp"
        },

        {
            path: "/images/gallery/gallery-15.webp"
        },
        {
            path: "/images/gallery/gallery-16.webp"
        },
        {
            path: "/images/gallery/gallery-17.webp"
        },
        {
            path: "/images/gallery/gallery-18.webp"
        },
        {
            path: "/images/gallery/gallery-19.webp"
        },
        {
            path: "/images/gallery/gallery-20.webp"
        },
        {
            path: "/images/gallery/gallery-21.webp"
        },
        {
            path: "/images/gallery/gallery-22.webp"
        },
        {
            path: "/images/gallery/gallery-23.webp"
        },
        {
            path: "/images/gallery/gallery-24.webp"
        },
        {
            path: "/images/gallery/gallery-25.webp"
        },
        {
            path: "/images/gallery/gallery-26.webp"
        },
        {
            path: "/images/gallery/gallery-27.webp"
        },
      ]

  return (
    <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: hasLoaded ? 1 : 0 }}
    transition={{ duration: 0.7 }}
  >
    <Helmet>
      <title>Volto Consulting | Business &amp; Technology Solutions</title>
      <meta
        name="description"
        content="Volto Consulting provides innovative business and technology solutions to drive success in a digital world."
      />
      <meta
        name="keywords"
        content="Volto Consulting, business consulting, IT solutions, technology strategy, digital transformation"
      />
      <meta name="author" content="Volto Consulting" />
      <meta
        property="og:title"
        content="Volto Consulting | Business &amp; Technology Solutions"
      />
      <meta
        property="og:description"
        content="Volto Consulting offers expert business and IT consulting services to enhance your digital transformation journey."
      />
    </Helmet>
    <div className="volto-privacy-policy ">
      <Header mode="light" />
      <div class="voloto-banner">
    <Container className='h-85'>
      <Row className=''>
        <Col lg={10} md={10} className=''>
          <SectionHeader mainText1="Gallery"  />
          <h1>Our Moments of Joy</h1>
        </Col>
      </Row>
    </Container>
    
   <img className='banner-vector' src="images/Union.svg" alt="vector" />
  </div>
      <Container className="mt-lg-0 mt-5 pb-80 volto-section">
        <Row>
            <Col lg={12}>
            <ResponsiveMasonry
                columnsCountBreakPoints={{350: 1, 750: 2, 900: 3}}
                gutterBreakpoints={{350: "12px", 750: "16px", 900: "40px"}}
            >
                <Masonry className="mansory-grid" sequential= {true}>
                    {
                        galleryItems.map((item, index) => (
                            <div key={index} className="masonry-grid-item">
                                <a data-fancybox="gallery" href={item.path}>
                                    <img src={item.path} alt="Gallery Item" />
                                </a>
                            </div>
                        ))
                    }
                </Masonry>
            </ResponsiveMasonry>
            </Col>
        </Row>

    
        
      </Container>
      <Footer />
    </div>
  </motion.div>
  )
}

export default GalleryPage
